import { getOrder } from '../../order/requests/get-order';

export const getLoyaltyFullOrder = async (organisationId: string, sessionId: string) => {
  const fullOrder = await getOrder({ organisationId, sessionId });
  return fullOrder;
};
